<template>
	<div class="brick">
		<div class="view_inner">
			<div class="divide_tbl">
				<table class="view_tbl" border="0">
					<colgroup>
						<col style="width:130px;" />
						<!-- <col style="width:400px;" /> -->
						<col style="" />
						<col style="width:130px;" />
						<col style="" />
					</colgroup>
					<tbody>
						<tr>
							<th>Slip No</th>
							<td>
								<input type="text" v-model.trim="slip.slip_dn" class="tbl_int ssm2_int" readonly disabled />
							</td>
							<th></th>
							<td></td>
						</tr>
						<tr>
							<th>Type</th>
							<td>
								<CodeSelect className="tbl_select" :codes="slipTypeCodes" :showDesc="true" :codeBold="true" :descBold="true" v-model="slip.slip_type" />
							</td>
							<th></th>
							<td></td>
							<!-- <th>Entry User</th>
							<td>
								<input type="text" v-model.trim="slip.crt_name" class="tbl_int ssm2_int" readonly disabled />
								<template v-if="slip.upd_dt"> &nbsp;Last updated : {{ slip.upd_dt | moment('MM-DD-YYYY HH:mm:ss') }} by {{ slip.upd_name }} </template>
							</td> -->
						</tr>
						<tr>
							<th>Slip Date</th>
							<td>
								<CustomDatePicker v-model="slip.slip_date" :disabled="mode == 'detail'" />
							</td>
							<th>Sales Group</th>
							<!-- <td><CodeSelect className="tbl_select" :codes="salesGroups" v-model="invoice.sales_group_code" /></td> -->
							<td><CodeSelect className="tbl_select" :codes="salesGroups" v-model="slip.sales_group_code" /></td>
						</tr>
						<tr>
							<th>Description</th>
							<td colspan="3">
								<input type="text" v-model.trim="slip.description" class="tbl_int full_int" />
							</td>
						</tr>
						<tr>
							<th>Quantity / Amount</th>
							<td>
								<currency-input type="text" v-model="slip.total_quantity" :precision="0" class="tbl_int ssm_int al_right" readonly />
								<currency-input type="text" v-model="slip.total_amount" class="tbl_int ssm_int al_right" readonly />
								<currency-input type="text" v-if="company_id == 'beautyplus'" v-model="slip.total_fob" class="tbl_int ssm_int al_right" readonly />
							</td>

							<th></th>
							<td></td>
						</tr>
					</tbody>
				</table>
			</div>

			<!-- New Item -->
			<div class="left_option" style="display:inline;">
				<span class="int_type half_int">
					<autocomplete ref="ac" :initialDisplay="keyword" :source="selectClasses" @nothingSelected="searchKeyword" @selected="selectClass" results-display="code_name" :placeholder="'Item / ' + headers.class + ' Name or Code / Barcode'">
					</autocomplete>
				</span>

				<a href="javascript:;" class="search_bt" @click="search()">Search and Add Item(s)</a>
			</div>

			<div>
				<table class="list_tbl mgb_0 add_top_line" ref="slip_items">
					<thead>
						<tr>
							<th width="3%"><input type="checkbox" @change="selectAll()" v-model="allSelected" /></th>
							<th width="10%">{{ headers.class }}</th>
							<th>Name</th>
							<th width="15%">Color</th>
							<th width="7%">Qty({{ qtyToggleMode ? '+' : '-' }})<a href="javascript:;" class="gray_bt2" style="margin-left:2px;height:16px;line-height: 16px;" @click="plusMinus()">+ / -</a></th>
							<th width="7%">Price<a v-if="priceAutoCalcable" href="javascript:;" class="gray_bt2" style="margin-left:2px;height:16px;line-height: 16px;" @click="calcPriceByFob()">Auto.</a></th>
							<th width="7%">Amount</th>
							<th width="5%">FOB Cost</th>
							<th width="5%">FOB Amount</th>
							<th width="7%">On Hand</th>
							<th width="7%">Available</th>
							<th width="7%">On Board</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(item, index) in items" v-bind:key="item.slip_item_no">
							<td class="al_center"><input type="checkbox" v-model="item.selected" /></td>
							<td class="al_left">
								<template v-if="index == 0 || (index > 0 && item.class_code != items[index - 1].class_code)">
									{{ item.class_code }}
								</template>
							</td>
							<td class="al_left">
								<b v-if="item.active_yn == 'N'"><font color="red">!!</font></b>
								<a href="javascript:;" @click="selectItem(item)"
									><font :color="item.class_closed_yn == 'Y' ? 'gray' : 'black'">{{ item.name }}</font></a
								>
							</td>

							<td class="al_left">{{ item.color_code }}</td>
							<td class="al_right">
								<currency-input
									type="text"
									v-model.trim="item.quantity"
									:precision="0"
									class="r_int long_type al_right"
									@focus="$event.target.select()"
									ref="quantity"
									@keydown.down.prevent="goTo('quantity', index + 1)"
									@keydown.up.prevent="goTo('quantity', index - 1)"
									@keydown.enter.prevent="goTo('quantity', index + 1)"
								/>
							</td>
							<td class="al_right">
								<currency-input
									type="text"
									v-model.trim="item.price"
									:precision="2"
									class="r_int long_type al_right"
									@focus="$event.target.select()"
									ref="price"
									@keydown.down.prevent="goTo('price', index + 1)"
									@keydown.up.prevent="goTo('price', index - 1)"
									@keydown.enter.prevent="goTo('price', index + 1)"
								/>
							</td>
							<td class="al_right">
								<currency-input type="text" v-model.trim="item.amount" :precision="2" class="r_int long_type al_right" disabled />
							</td>
							<td class="al_right">{{ item.im_fob | toCurrency }}</td>
							<td class="al_right">{{ item.fob_amount | toCurrency }}</td>
							<td class="al_right">{{ item.on_hand | commaSeparated }}</td>
							<td class="al_right">
								<span :style="item.quantity > 0 && item.quantity > item.available_quantity ? 'color:red;font-weight:bold;' : ''">{{ item.available_quantity | commaSeparated }}</span>
							</td>
							<td class="al_right">{{ item.on_board_quantity | commaSeparated }}</td>
						</tr>
					</tbody>
				</table>
			</div>

			<div class="tbl_bottom_bt">
				<input type="button" value="Delete" class="int_line_bt" @click="deleteItems()" />
				<span style="padding-left:20px"># of item row:</span>
				<input type="text" readonly disabled="disabled" style="width:40px;" class="r_int long_type al_right" v-model="items.length" />

				<!-- <input type="button" value="Copy" class="int_line_bt" style="margin-left:5px" @click="copyItems()" />
				<input v-if="slip.status_code != 'D' && slip.status_code != 'T'" type="button" value="Paste" class="int_line_bt" style="margin-left:5px" @click="pasteItems()" /> -->
			</div>

			<div class="view_bottom_bt">
				<a v-if="modifiable" href="javascript:;" type="button" class="search_bt" @click="save(false)">Save & Return</a>
				<a v-if="modifiable" href="javascript:;" type="button" class="search_bt mgr_15" @click="save(true)">Save Only</a>
				<a v-if="modifiable && mode == 'detail' && !slip.inventory_applied" href="javascript:;" type="button" class="search_bt mgr_15" @click="applyInventory()">Apply Inventory</a>
				<!-- <a v-if="modifiable && mode == 'detail'" href="javascript:;" type="button" class="search_bt mgr_15" @click="applyInventory()">Apply Inventory</a> -->

				<a v-if="mode === 'detail'" href="javascript:void(0);" type="button" class="search_bt" @click="print()">Print</a>
				<a v-if="mode === 'detail'" href="javascript:void(0);" type="button" class="search_bt mgr_15" @click="excel()">Excel</a>
				<a href="javascript:;" type="button" class="gray_bt" @click="back()">Back</a>
			</div>
		</div>

		<Modal @close="closeModal" v-if="showModal && modalName == 'ItemSelect'" :draggable="false" style="z-index:2000">
			<template slot="title">Select Item(s)</template>
			<template slot="body">
				<ItemPopup :initialItems="searchItems" :initialItemClass="this.itemClass" :initialKeyword="keyword" :includeInactive="true" :operation="'N'" @close="closeModal()" @set-items="addItems" />
			</template>
		</Modal>
	</div>
</template>

<script>
import { inputSelectOnClick } from '@/utils/etc.js';
import { apiIndex, apiSelectSlip, apiSelectSlipItemList, apiInsertSlip, apiUpdateSlip, apiApplyInventory, apiUpdateSlipPrint } from '@/api/purchase/slip.js';
//import { apiCheckInactiveItemExists } from '@/api/sales/invoice.js';
//import { apiSelectPartner } from '@/api/partner/index.js';
//import { apiIndex, apiSelectSlip } from '@/api/sales/slip.js';
//import { apiSelectCallTag } from '@/api/sales/calltag.js';
//import { apiSelectItemList } from '@/api/item/master.js';
// import { apiDownloadFile, apiUploadFile } from '@/api/util.js';
// import { apiSelectCodeList } from '@/api/basicinfo/code.js';
import CodeSelect from '@/components/common/CodeSelect';
//import PartnerSelect from '@/components/common/PartnerSelect';
// import Modal from '@/components/common/Modal';
import CustomDatePicker from '@/components/common/CustomDatePicker.vue';
import { today } from '@/utils/date.js';
//import { getPossibleStatus } from '@/main.js';

//import ItemClassSelect from '@/components/common/ItemClassSelect';
import ItemPopup from '@/components/common/ItemPopup';
//import ReceiptPopup from '@/components/common/ReceiptPopup';
import Modal from '@/components/common/Modal';
import { defaultDataType } from 'export-xlsx';

import _ from 'lodash';

import 'floatthead';
import { exportDataExcel, reportMrtUrl, reportRenderBase64 } from '@/api/util';
//import { apiGetReportTemplate, companyMrtUrl, objectToFormData, PrintType, Report } from '@/api/util';

export default {
	props: ['headers'],
	data: function() {
		return {
			backUri: '/sales/slip',

			mode: 'add',

			slip: {
				slip_dn: null,
			},

			popup_items: [],

			//acClasses: [],
			//acSelected: null,

			items: [],
			item_nos_to_delete: [],

			salesGroups: [],

			slipTypeCodes: [],

			allSelected: false,

			itemClass: null,
			keyword: '',
			searchItems: [],

			modalName: '',
			showModal: false,

			qtyToggleMode: true, // true : plus, false : minus
		};
	},
	computed: {
		modifiable() {
			var menus = this.$session.get('menus');
			for (var i = 0; i < menus.length; i++) {
				if ((menus[i].path == this.$router.history.current.path || menus[i].path == this.$router.history.current.path.replace('add', 'detail')) && menus[i].modify_yn == 'Y') return true;
			}
			return false;
		},
		user: function() {
			return this.$session.get('user');
		},
		company_id() {
			return this.user ? this.user.company_id : null;
		},
		fob_price_view() {
			return this.user ? this.user.fob_price_view || false : false;
		},
		priceAutoCalcable() {
			return ['beautyplus', 'hairplus'].includes(this.company_id) && this.fob_price_view;
		},
	},
	watch: {
		slip: {
			deep: true,
			handler: function() {
				this.calTotal();
			},
		},
		items: {
			deep: true,
			handler: function() {
				this.calTotal();
			},
		},
	},
	components: {
		//PartnerSelect,
		//Modal,
		CodeSelect,
		CustomDatePicker,
		//ItemClassSelect,
		ItemPopup,
		Modal,
		//Paging,
		//ReceiptPopup,
	},
	methods: {
		calcPriceByFob() {
			this.items.forEach(item => {
				item.price = Math.round((item.lock_price || 0) * 0.75 * 100) / 100; // 소수점 이하 두자리까지 표시
			});
		},
		plusMinus() {
			this.qtyToggleMode = !this.qtyToggleMode;

			this.items.forEach(i => {
				i.quantity = i.quantity * -1;
			});
		},
		back() {
			this.$router.push(this.backUri);
		},
		goTo(colType, index) {
			this.$nextTick(() => {
				if (index < this.items.length && index >= 0) {
					if (colType == 'price') this.$refs.price[index].$el.select();
					else if (colType == 'quantity') this.$refs.quantity[index].$el.select();
				}
			});
		},

		selectClasses(input) {
			var url = process.env.VUE_APP_API_URL + '/api/item/item_class/acClassList?company_id=' + this.user.company_id + '&include_barcode_yn=Y&keyword=' + input;
			//if (this.invoice.invoice_type == 'R') url += '&include_closed_yn=Y';

			//console.log(url);
			return url;
			//return process.env.VUE_APP_API_URL + '/api/item/item_class/acClassList?company_id=' + this.user.company_id + '&keyword=' + input;
		},
		selectClass(c) {
			this.$refs.ac.clear();
			this.itemClass = c.selectedObject.code;
			this.search();

			this.keyword = null;
			//this.searchKeyword(c.selectedObject.code);

			//console.log(str);
		},
		searchKeyword(keyword) {
			//console.log(keyword);

			this.$refs.ac.clear();
			this.keyword = keyword;
			this.search();

			this.itemClass = null;
			//this.keyword = null;
		},

		selectItem(item) {
			this.$router.push({ name: 'itemMaster', params: {}, query: { backUri: this.$route.fullPath, keyword: item.item_id } });
		},

		setItemClass(itemClass) {
			//console.log('hmmm', itemClass);
			this.itemClass = itemClass.code;
			//console.log(this.itemClass);
			//console.log('set item class');
			this.search();
		},
		async search() {
			this.openModal('ItemSelect');
		},
		reset() {
			this.keyword = '';
			this.itemClass = null;
		},
		deleteItems() {
			for (var i = this.items.length - 1; i >= 0; i--) {
				if (this.items[i].selected) {
					if (this.items[i].slip_item_no) this.item_nos_to_delete.push(this.items[i].slip_item_no);
					this.items.splice(i, 1);
				}
			}
		},
		selectAll() {
			//console.log(this.allSelected);
			var vm = this;
			this.items.forEach(function(item) {
				item.selected = vm.allSelected;
			});
		},

		calTotal() {
			var total_amount = 0;
			var total_quantity = 0;
			var total_fob = 0;

			this.items.forEach(function(item) {
				item.amount = item.quantity * item.price;
				item.fob_amount = item.quantity * item.im_fob;

				total_quantity += item.quantity;
				total_amount += item.amount;
				total_fob += item.fob_amount;
			});

			this.slip.total_quantity = total_quantity;
			this.slip.total_amount = total_amount;
			this.slip.total_fob = total_fob;
		},

		async selectSlip() {
			const { data } = await apiSelectSlip({
				slip_no: this.slip.slip_no,
			});

			this.slip = data.slip;
			this.items = data.slipItemList;

			if (this.slip.total_quantity < 0) this.qtyToggleMode = false;
		},
		checkValidity() {
			if (!this.slip.slip_date) {
				this.$toast.error('Empty Slip Date');
				return false;
			}

			return true;
		},

		applyInventory() {
			//this.$alertify.confirm('Are you sure to apply inventory? Further application is not allowed.', () => {
			this.$alertify.confirm('Are you sure to apply inventory?', () => {
				//console.log('process shipment');
				this.applyInventoryConfirm();
			});
		},

		async applyInventoryConfirm() {
			this.slip.items = this.items;
			this.slip.item_nos_to_delete = this.item_nos_to_delete;

			const { data } = await apiApplyInventory(this.slip);

			if (data.result) {
				this.$toast.success('Inventory applied successfully');
				await this.selectSlip();
			} else {
				this.$toast.error(data.msg);
			}
		},

		async save(stay) {
			if (this.checkValidity()) {
				await this.submit(stay);
			}
		},
		cancel() {
			this.$router.push(this.backUri);
		},
		async submit(stay) {
			//console.log(this.items);
			this.slip.items = this.items;
			this.slip.item_nos_to_delete = this.item_nos_to_delete;

			// this.$toast.info('Under Development');
			// var dummy = true;
			// if (dummy) {
			// 	console.log(this.slip, stay);
			// 	return;
			// }

			var response;
			if (this.mode == 'add') {
				response = await apiInsertSlip(this.slip);
			} else {
				response = await apiUpdateSlip(this.slip);
			}
			var data = response.data;

			if (data.result) {
				this.$toast.success('Saved successfully');

				//console.log(this.backUri);
				if (!stay) {
					this.$router.push(this.backUri);
				} else {
					if (this.mode == 'add') {
						this.slip.slip_no = data.slip_no;

						this.mode = 'detail';
						this.$store.commit('setSubTitle', 'Slip -> Detail');
					}
					await this.selectSlip();
				}
			} else {
				this.$toast.error(data.msg);
			}
		},

		openModal(modalName) {
			this.modalName = modalName;
			this.showModal = true;
		},
		closeModal() {
			this.showModal = false;
		},

		addItems(items) {
			var to_add_items = [];
			items.forEach(function(item) {
				item.im_cost = item.cost;
				item.im_fob = item.fob;

				item.price = item.net_price; // ItemPopup에 전달된 operation이 'N'이므로('S'인 경우만 net_price정보을 구함.) Item의 net_price값은 null임.
				to_add_items.push(item);
			});

			this.mergeItems(to_add_items);

			this.reset();
		},
		mergeItems(items) {
			var vm = this;
			items.forEach(function(item) {
				if (!vm.qtyToggleMode) item.quantity = -1 * item.quantity;

				var foundItems = vm.items.filter(i => i.item_id == item.item_id);
				if (foundItems.length > 0) foundItems[0].quantity += item.quantity;
				else vm.items.push(_.cloneDeep(item));
			});
		},
		async index() {
			const { data } = await apiIndex();

			// this.paymentTerms = data.paymentTermList;
			// this.shipCharges = data.shipChargeList;
			this.salesGroups = data.salesGroupList;
			this.slipTypeCodes = data.slipTypeList;
			// this.deliveryTypes = data.deliveryTypeList;
			// this.returnTypes = data.returnTypeList;
			// this.remarks = data.remarkList;
			// this.specialSales = data.specialSaleList;
			// this.locationList = data.locationList;
		},
		async init() {
			await this.index();
			this.slipStatusCodes = this.$slipStatusCodes;

			// var response;

			if (this.mode == 'detail') {
				await this.selectSlip();
				//console.log(getPossibleStatus(this.invoice.status_code));
				//this.saleStatusCodes = getPossibleStatus(this.invoice.status_code);
			}
			inputSelectOnClick();
		},
		// async test() {
		// 	const { data } = await apiInsertInvoice(this.invoice);

		// 	if (data.result) {
		// 		this.$toast.success('Saved successfully');
		// 	} else {
		// 		this.$toast.error(data.msg);
		// 	}
		// },
		async excel() {
			const { data } = await apiSelectSlipItemList(this.slip.slip_no);
			data.forEach(d => {
				d.fob_amount = d.quantity * d.im_fob;
			});

			const headers = [
				{ key: 'class_code', name: this.headers.class, width: 15, dataType: defaultDataType.string },
				{ key: 'class_closed_yn', name: 'Closed ' + this.headers.class, width: 15, dataType: defaultDataType.string },
				{ key: 'active_yn', name: 'Active Item', width: 15, dataType: defaultDataType.string },
				{ key: 'name', name: 'Item Name', width: 30, dataType: defaultDataType.string },
				{ key: 'color_code', name: 'Color Code', width: 15, dataType: defaultDataType.string },
				{ key: 'quantity', name: 'Quantity', width: 15, dataType: defaultDataType.currency },
				{ key: 'price', name: 'Price', width: 15, dataType: defaultDataType.number },
				{ key: 'amount', name: 'Amount', width: 15, dataType: defaultDataType.number },
				{ key: 'im_fob', name: 'FOB Cost', width: 15, dataType: defaultDataType.number },
				{ key: 'fob_amount', name: 'FOB Amount', width: 15, dataType: defaultDataType.number },
				{ key: 'on_hand', name: 'On Hand', width: 15, dataType: defaultDataType.currency },
				{ key: 'available_quantity', name: 'Available', width: 15, dataType: defaultDataType.currency },
				{ key: 'on_board_quantity', name: 'On Board', width: 15, dataType: defaultDataType.currency },
			];

			exportDataExcel(data, headers, 'SLIP_' + this.slip.slip_dn);
		},
		print() {
			const renderReport = function(data) {
				return new Promise(resolve => {
					resolve(reportRenderBase64(data, 'Slip', reportMrtUrl('Slip')));
				});
			};
			apiSelectSlip({ slip_no: this.slip.slip_no }).then(xhr => {
				renderReport(xhr.data).then(() => {
					if (!xhr.data.slip.print_dt && !xhr.data.slip.print_user) apiUpdateSlipPrint(this.slip.slip_no);
				});
			});
		},
	},
	created() {
		this.slipStatusCodes = this.$;
		if (this.$route.query.backUri) this.backUri = this.$route.query.backUri;
		this.mode = this.$route.params.mode;

		this.$store.commit('setSideIndex', 2);
		this.$store.commit('setSelectedMenu', 'nav_li_slip');

		if (this.mode == 'add') {
			this.$store.commit('setSubTitle', 'Slip -> Add');
			this.slip.slip_date = today();
		} else {
			this.$store.commit('setSubTitle', 'Slip -> Detail');
			this.slip.slip_no = this.$route.query.slip_no;

			if (!this.slip.slip_no) {
				//console.log('empty...', this.backUri);
				this.$router.push(this.backUri);
				return;
			}
		}

		this.init();
		//console.log(this.user);

		// this.selectDepts();
		// this.selectSalesTeams();
	},
	mounted() {
		inputSelectOnClick();
		//$(this.$refs.invoice_items).floatThead({ zIndex: 1, autoReflow: true });

		// if (this.mode == 'add') {
		// 	this.$nextTick(function() {
		// 		this.$refs.shipto.$el.children[0].focus();

		// 	});
		// }
	},
};
</script>

<style>
td a:hover {
	text-decoration: underline;
	color: #ff0000;
}
</style>
